<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="500"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>AMORTIZAR CUENTA POR COBRAR</span>
        </div>
        <div class="pl-3 pt-3 pr-3" style="height: 80vh;" v-if="debt">
            <template>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-title class="pt-2 pb-2">
                                <span class="subtitle-2">Información de proveedor</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pt-1 pb-1 amortize-debt">
                                <v-container class="pt-1 pb-1">
                                    <v-row>
                                        <v-col cols="12" class="pt-1 pb-1">
                                            <span>Proveedor:</span>
                                            <span class="float-right">{{ debt.supplier_name }}</span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="pt-1 pb-1">
                                            <span>Deuda Total:</span>
                                            <span class="float-right">{{ debt.total_amount | currency('S/') }}</span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="pt-1 pb-1">
                                            <span>Monto Pendiente:</span>
                                            <span class="float-right total-pending">{{ debt.pending_amount | currency('S/') }}</span>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-title class="pt-2 pb-2">
                                <span class="subtitle-2">Pago</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pt-1 pb-0">
                                <v-container>
                                    <v-row>
                                        <v-col cols="6" class="pt-2 pb-2">
                                            <v-combobox
                                                ref="payment_method"
                                                v-model="form.payment_method"
                                                label="Método de pago"
                                                :items="payment_type"
                                                outlined
                                                :rules="[() => !!form.payment_method || 'Es necesario seleccionar un método de pago']"
                                                hide-details="auto"
                                                required>
                                            </v-combobox>
                                        </v-col>
                                        <v-col cols="6" class="pt-2 pb-2">
                                            <v-text-field
                                                ref="amount"
                                                v-model="form.amount"
                                                label="Monto"
                                                prefix="S/"
                                                type="number"
                                                outlined
                                                :rules="[() => !!form.amount || 'Es necesario ingresar el monto a pagar']"
                                                hide-details="auto"
                                                required
                                                >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    
                                    <v-col cols="12" class="pt-2 pb-2" v-if="form.payment_method=='CUENTA BANCARIA'">
                                            <v-autocomplete
                                                ref="account_id"
                                                :items="accounts"
                                                label="Cuentas"
                                                outlined
                                                :item-text="customTextV2"
                                                item-value="id"
                                                clearable
                                                :value="account_id"
                                                @change="set_account_id"
                                                hide-details="auto"
                                                required
                                            ></v-autocomplete>
                                        </v-col>
                                        
                                        <v-col cols="12" class="pt-2 pb-2" v-if="form.payment_method=='CAJA'">
                                            <v-autocomplete
                                                ref="till_id"
                                                :value="till_id"
                                                :items="tills"
                                                label="Cajas"
                                                outlined
                                                :item-text="customText"
                                                item-value="id"
                                                @change="set_till_id"
                                                hide-details="auto"
                                                required
                                            ></v-autocomplete>
                                        </v-col>

                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-title class="pt-2 pb-2">
                                <span class="subtitle-2">Historial</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="amortize-debt history-payments">
                                <v-simple-table dense class="table-kardex">
                                    <thead class="table-kardex-head">
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Hora</th>
                                            <th>Monto</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-kardex-body">
                                        <tr v-for="payment in debt.payments" :key="payment.id">
                                            <td>{{ payment.created_at | moment('DD/MM/YYYY') }}</td>
                                            <td>{{ payment.created_at | moment('hh:mm a') }}</td>
                                            <td>
                                                {{ payment.payment_amount | currency('S/') }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
        </div>

        <div class="mt-2 pl-3 pt-2 pr-3">
            <template>
                <v-row>
                    <v-col cols="6" class="pt-3 pb-3">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="pt-3 pb-3">
                        <v-btn dark color="success" block height="40" @click="handleStore">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Pagar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </div>

    </v-navigation-drawer>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex';

import TicketTools from '../../helpers/TicketTools';

import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'AmortizeSupplier',
    data () {
        return {
            drawer: false,
            accountName: [],
            payment_type: ['CAJA','CUENTA BANCARIA'],
            form: {
                debt_id: null,
                amount: null,
                payment_method: null,
                till_id: null,
                accountOrTill: null,
            }
        }
    },
    computed: {
        ...mapState('supplier-accounts', [
            'debt',
            'response_payment',
            'accounts'
        ]),
        ...mapState('purchases', [
            'account_id',
            'till_id',
            //'set_origin_id'
        ]),
        ...mapState('tills', [
            'selected_till'
        ]),
        ...mapState('accounts', [
            'accounts',
            //'account_id'
        ]),
        ...mapState('tills', [
            'tills',
            //'till_id'
        ])
    },
    
    methods: {
        ...mapActions('supplier-accounts', [
            'getDebts',
            'selectDebt',
            'storeAmortize'
        ]),
        
        ...mapMutations('purchases', [
            'set_till_id',
            'set_account_id'
        ]),
        customText(item){
            let text = item.name
            return text
        },
        ...mapActions('notifications', [
            'store_notification'
        ]),
        ...mapActions('accounts', [
            'getAccounts',
            //'set_account_id'
        ]),
        ...mapActions('tills', [
            'getTills'
        ]),
        customTextV2(item){
            let text = item.bank.name+' ('+item.number_account+')'
            return text
        },
        async show () {
            // console.log(this.accounts)
            this.getAccounts();
            this.getTills();
            await this.clearData();
            this.form.debt_id = this.debt.id;
            this.form.till_id = this.selected_till.id;
            this.drawer = !this.drawer
        },
        clearData () {
            this.form.debt_id = null;
            this.form.amount = null;
            this.form.payment_method = null;
            this.form.till_id = null;
            this.clearErrors();
        },
        closeForm () {
            this.drawer = false;
        },
        handleCancel () {
            this.clearData();
            this.closeForm();
            this.selectDebt(null);
        },
        async handleStore () {
            if (!this.existErrors()) {
                if(this.form.payment_method === 'CUENTA BANCARIA'){
                    this.form.accountOrTill = this.account_id;
                }else if(this.form.payment_method === 'CAJA'){
                    this.form.accountOrTill = this.till_id;
                }else if(this.form.accountOrTill === null){
                    this.store_notification({
                        type: 'error',
                        message: 'Caja se encuentra cerrada.'
                    });
                }
                await this.storeAmortize(this.form);
                this.closeForm();
                this.selectDebt(null);
            }
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.form).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.form[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.form).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
        async handlePrintVoucher (sale) {
            if (sale) {
                let content = await TicketTools.printTicketVenta(sale);
                this.printVoucher(content);
            }            
        },
        printVoucher (content) {
            $('<iframe>', {name: 'voucheriframe',class: 'printFrame'})
            .appendTo('body')
            .contents().find('body')
            .append(content);

            window.frames['voucheriframe'].focus();

            setTimeout(() => {                 
                window.frames['voucheriframe'].print();
             }, 500);

            setTimeout(() => { $(".printFrame").remove(); }, 1000);
        }
    }
}
</script>

<style scoped>
.total-pending{
    color: #F44336;
}

.amortize-debt{
    font-size: .9rem !important;
    color: #000000 !important;
}

.history-payments{
    height: 23vh;
    overflow-y: auto;
}
</style>